export enum Product {
  MULTISPORT = 'Multisport',
  MULTILIFE = 'MultiLife',
  MYBENEFIT = 'myBenefit',
  WELLBEING = 'Usługi wellbeingowe',
}

export const PRODUCT_NAME: Record<Product, string> = {
  [Product.MULTISPORT]: 'ms',
  [Product.MULTILIFE]: 'ml',
  [Product.MYBENEFIT]: 'myb',
  [Product.WELLBEING]: 'wellbeing_services',
}
